


















import path from 'path';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Route, RouteConfig } from 'vue-router';
import { translateRouteTitle } from '@/utils/permission';

@Component({
  name: 'AppSidebarSingleItem',
})
export default class extends Vue {
  @Prop({ default: '' }) private basePath!: string;
  @Prop({ required: true }) private item!: RouteConfig;

  private resolvePath(subPath: string) {
    return path.resolve(this.basePath, subPath);
  }

  private translateRouteTitle(title: string) {
    return translateRouteTitle(this.$i18n, title);
  }
}
